export const API_BASE_URL = "https://appwrapper.ondchub.com/route";

export const endpoint = {
  GET_ANALYTICS: `${API_BASE_URL}/seller/api/V1/dashboard/analyticOrderDashboard`,
  GET_IGM_ANALYTICS: `${API_BASE_URL}/igm/api/V1/issues/analytics`,
  GET_ORDERS: `${API_BASE_URL}/seller/api/V1/dashboard/ondcOrders`,
  GET_ORDER_DETAIL: `${API_BASE_URL}/seller/api/V1/dashboard/ondcCompleteOrder/`,
  GET_CATALOGUE_REJECTION: `${API_BASE_URL}/seller/api/V1/dashboard/getCatalogRejection`,
  GET_CATALOGUE_REJECTION_DOMAIN: `${API_BASE_URL}/seller/api/V1/dashboard/getCatalogRejectionDomain`,
  GET_CATALOGUE_REJECTION_BAP_ID: `${API_BASE_URL}/seller/api/V1/dashboard/getCatalogRejectionBapId`,
  DELETE_CATALOGUE: `${API_BASE_URL}/seller/api/V1/dashboard/deleteCatalogRejection/`,
  UPDATE_CATALOGUE: `${API_BASE_URL}/seller/api/V1/dashboard/updateCatalogRejection`,
  GET_STORE_DETAILS: `${API_BASE_URL}/seller/api/V1/dashboard/getStoreDashboardDetails`,
  UPDATE_STORE_DETAILS: `${API_BASE_URL}/seller/api/V1/dashboard/updateStoreDashboardDetails`,
  GET_SERVICABILITIES: `${API_BASE_URL}/seller/api/V1/dashboard/getServiceableLocations`,
  UPDATE_SERVICABILITIES: `${API_BASE_URL}/seller/api/V1/dashboard/updateServiceableLocation`,

  GET_ISSUES: `${API_BASE_URL}/igm/api/V1/issues/getList`,
  GET_ISSUE_DETAILS: `${API_BASE_URL}/igm/api/V1/issues/getIssueDetails`,
  REQUEST_INFO: `${API_BASE_URL}/igm/api/V1/issues/requestInfo`,
  PROVIDE_RESOLUTION: `${API_BASE_URL}/igm/api/V1/issues/issueResolution`,
  GET_GRIEVANCES: `${API_BASE_URL}/igm/api/V1/issues/getList`,
  RESPOND_TO_RESOLUTION: `${API_BASE_URL}/igm/api/V1/issues/respondToResolution`,
  PROVIDE_INFO: `${API_BASE_URL}/igm/api/V1/issues/provideInfo`,
  ESCALATE_ISSUE: `${API_BASE_URL}/igm/api/V1/issues/escalateIssue`,
  RAISE_ISSUE: `${API_BASE_URL}/igm/api/V1/issues/raiseIssue`,
  RAISE_RECON_ISSUE: `${API_BASE_URL}/igm/api/V1/recon/raiseIssue`,
  CLOSE_ISSUE: `${API_BASE_URL}/igm/api/V1/issues/close`,
  RESOLVE_ISSUE: `${API_BASE_URL}/igm/api/V1/issues/resolveIssue`,
  CONTACT_US: `${API_BASE_URL}/igm/api/V1/support/contact_us`,
  GET_FAQS: `${API_BASE_URL}/igm/api/V1/support/faqs`,
  REQUEST_STATUS: `${API_BASE_URL}/igm/api/V1/issues/requestStatus`,

  SEND_SETTLEMENT_REQUEST: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/sendRequest`,
  SEND_ON_RECON_REQUEST: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/recon/submit-on-recon`,
  GET_SETTLEMENTS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlements`,
  GET_SETTLEMENT_DETAILS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementDetailById/`,
  GET_RECONS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/recon/getRecons`,
  RAISE_RECON: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/recon/raiseRecon`,
  GET_RECONS_DETAIL: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/recon/getReconDetailById/`,
  SEND_MISC_SETTLEMENT_REQUEST: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/sendMiscRequest`,
  GET_ORDER_DETAILS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/orders/getOrder/`,
  GET_MISC_SETTLEMENTS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getMiscSettlements`,
  GET_MISC_SETTLEMENT_DETAILS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementMiscDetails/`,
  GET_SETTLEMENT_DETAILS_REQUEST: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/settlement/getSettlementDetails/`,
  RAISE_REPORT: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/report/raiseReport`,
  GET_REPORTS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/report/getReports`,
  GET_PAYOUTS: `${API_BASE_URL}/rsf/futuresoft/ondc/rsf/api/v2/payout/payout-screen`,
};
